import React from 'react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import AddressPage from '../AddressPage.jsx'
import api from '../../api.js'

function Addresses() {
  const [savedAddress, setSavedAddress] = React.useState(true);
  const [addressList, setAddressList] = React.useState([]);
  const [addressId, setAddressId] = React.useState(null);
  const [switches, setSwitches] = React.useState(true);
  const accessToken = localStorage.getItem('accessToken');
  const [add_new_address, setAdd_new_address] = React.useState(true);
  const navigate = useNavigate()


  useEffect(() => {
    if (switches) {
      const callAddressApi = async () => {
        try {
          const response = await api.get(`/user_api/checkout/get-checkout-details?access_token=${JSON.parse(accessToken)}`);
          if(response.data.address){
            setAddressList(response.data.address);
          }
          else{
            setAddressList([]);
          }
          // console.log("Fetched address list after switching to saved addresses", response);
        } catch (error) {
          console.error('Error fetching saved addresses:', error);
        }
      };
      callAddressApi();
    }
  }, [switches]);

  const handleAddress = () => {
    setAdd_new_address(false);
  }



  return (
    <div style={{ width: "100%", height: "100vh", display: "flex" }}>
      {addressList === 0 ? <div style={{ margin: "auto", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: "5px" }}>

        <img src='https://atlas-content-cdn.pixelsquid.com/stock-images/cartoon-house-RBxaG7A-600.jpg' width="200px" height="150px" style={{ background: "white" }} />
        <h3>No saved addresses</h3>
        <p>Add your addresses for fast and easy checkout across our marketplaces</p>
        <button style={{ backgroundColor: "blueviolet", border: "none", borderRadius: "5px", color: "white", padding: "10px 20px" }} onClick={handleAddress}>Add New Address</button>
      </div> :
        <AddressPage addressList={addressList} />

      }
      { }
    </div>
  )
}

export default Addresses